import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VForm, {
    ref: "form",
    staticClass: "scopeaccess-tree"
  }, [_c('core-n20Card', {
    class: !_vm.dialog ? 'dt-card-text-01' : null,
    attrs: {
      "elevation": "0",
      "form": _vm.$refs['scopeSelectorForm'],
      "buttons": [{
        type: 'submit',
        icon: 'fa-plus',
        title: _vm.$i18n_t('Common.save'),
        action: 'save'
      }]
    },
    on: {
      "save": function ($event) {
        (_vm.$refs['scopeAccessSelector'] || {}).emitRoles();
      }
    }
  }, [_c(VCardText, {
    class: _vm.paddingClass + ' pb-4'
  }, [_c('p', {
    staticClass: "headinfo px-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.scopeSelectionHeaderText')))])]), _c(VCardText, {
    class: _vm.paddingClass + ' pb-4'
  }, [_c(VForm, {
    ref: "scopeSelectorForm",
    model: {
      value: _vm.scopeSelectorFormValid,
      callback: function ($$v) {
        _vm.scopeSelectorFormValid = $$v;
      },
      expression: "scopeSelectorFormValid"
    }
  }, [_c('core-tenant-scope-access-selector', {
    ref: "scopeAccessSelector",
    attrs: {
      "subject": "all",
      "action": "manage",
      "userId": _vm.userId,
      "roles": _vm.roles,
      "isLoading": _vm.isLoading,
      "allowEmptyRoleSet": _vm.allowEmptyRoleSet
    },
    on: {
      "scopeChosen": scopeId => _vm.$emit('scopeChosen', scopeId),
      "scopeRolesChosen": _vm.rolesChosen
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };